@if (displaySearchDialog) {
  <app-account-tree-popup [displaySearchDialog]="displaySearchDialog"
    (onSubmit)="onSelect($event)" (onCancel)="cancelSearch()"
    [selectedAccount]="selectedAccount"
    [kindOfAccountType]="kindOfAccountType"
    [loadAccount]="loadAccount" [allowSelectAccountType]="allowSelectAccountType">
  </app-account-tree-popup>
}